export default __webpack_public_path__ + "static/media/CNo.18-0.2672253c.jpg";